module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showItem && _vm.src) ? _c('figure', {
    ref: ("rain-item-" + _vm.rainId),
    staticClass: "rain-item weex-el weex-image",
    style: (_vm._px2rem(_vm.pos, 75)),
    attrs: {
      "src": _vm.src,
      "data-img-src": _vm.src,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.caught($event)
      }
    }
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46b9a76d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46b9a76d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-lottery-rain/rain-item.vue
// module id = 602
// module chunks = 0 1